import { render, staticRenderFns } from "./SaplingScreenCapture.vue?vue&type=template&id=2fd4971d&scoped=true"
import script from "./SaplingScreenCapture.vue?vue&type=script&lang=ts"
export * from "./SaplingScreenCapture.vue?vue&type=script&lang=ts"
import style0 from "./SaplingScreenCapture.vue?vue&type=style&index=0&id=2fd4971d&prod&scoped=true&lang=scss"
import style1 from "./SaplingScreenCapture.vue?vue&type=style&index=1&id=2fd4971d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4971d",
  null
  
)

export default component.exports